/**
 增值服务
 */
import React, { Component } from 'react';
import styles from './index.module.scss';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { message, Input, Select } from 'antd';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import { XSelect, XOKButton, XCancelButton, XDatePicker, XInput, XTableAdapter } from '@/components/xqxc_ui';
import TableContent from './components/TableContent';
import model from '@/reducers/order/virtualno/model';
import moment from 'moment';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import NoteInfo from './modal/NoteInfo';
import Play from './modal/Play';

const { Option } = Select;
const callTypes = [
    { code: '0', value: '主叫' },
    { code: '1', value: '被叫' },
    { code: '2', value: '虚拟号' }
];
const types = [
    { code: 'CALL', value: '语音' },
    { code: 'SMS', value: '短信' },
];
class VirtualNo extends Component {

    static propTypes = {
        history: PropTypes.object, // 路由history对象
        match: PropTypes.object,
        getVirtualNoRecords: PropTypes.func,
        virtualNoRecords: PropTypes.object
    }

    static defaultProps = {
        renderData: { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 }
    }

    state = {
        renderModal: '',
        modalParam: '',
        deliveryId: null,
        recordId: null,
        typeItem: {},
        tel: null,
        callItem: {},
        startTime: undefined,
        releaseTime: undefined,
        scrollY: '',
    }

    componentDidMount() {
        const { setBreadcrumbPaths, match } = this.props;
        setBreadcrumbPaths(match); // 自动识别面包屑
    }

    _searchHandle = (useCache) => {
        const { deliveryId, recordId, typeItem, tel, callItem, startTime, releaseTime, pageNum, pageSize } = this.state;
        let query = {
            deliveryId,
            recordId,
            tel,
            type: typeItem.code,
            callType: callItem.code,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        if (startTime && releaseTime && startTime == releaseTime) {
            query = { ...query, startTime: `${moment(startTime).format('YYYY-MM-DD')} 00:00:00`, releaseTime: `${moment(releaseTime).format('YYYY-MM-DD')} 29:59:59` }
        } else {
            query = { ...query, startTime: startTime ? `${moment(startTime).format('YYYY-MM-DD')} 00:00:00` : undefined, releaseTime: releaseTime ? `${moment(releaseTime).format('YYYY-MM-DD')} 29:59:59` : undefined }
        }
        this.props.getVirtualNoRecords(query);
        KeepAlive.saveCache({ ...query, startTime, releaseTime, typeItem, callItem }); // 【第3步，缓存查询状态】
    }

    _resetHandle = () => {
        this.setState({
            deliveryId: null,
            recordId: null,
            typeItem: {},
            tel: null,
            callItem: {},
            startTime: undefined,
            releaseTime: undefined
        }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    // 表格分页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this._searchHandle('useCache');
        });
    }

    ///请求
    _request = (url, data, tip) => {
        http(url, data, 'POST')
            .then(() => {
                this._searchHandle('useCache');
                message.success(tip);
            })
            .catch(err => message.error(err.message));
    }

    //生成报表
    _createCancel = () => {

    }

    //渲染弹窗
    _renderModal = () => {
        const { modalParam, renderModal } = this.state;
        switch (renderModal) {
            case 'play':
                return <Play closeModal={this._closeModal} modalParam={modalParam} />;
            case 'note':
                return <NoteInfo closeModal={this._closeModal} modalParam={modalParam} />;
            default:
                break;
        }
    }

    //关闭弹框
    _closeModal = () => {
        this.setState({ renderModal: '', modalParam: '' });
    }

    //操作
    _tableHandle = (type, params) => {
        switch (type) {
            case 'play':
                this.setState({ renderModal: 'play', modalParam: params.recordUrl });
                break;
            case 'note':
                this.setState({ renderModal: 'note', modalParam: params.smsContent });
                break;
            default:
                break;
        }
    }

    render() {
        const { deliveryId, recordId, tel, typeItem, callItem, startTime, releaseTime, scrollY } = this.state;
        const { virtualNoRecords, history } = this.props;

        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 调用查询接口初始化数据
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <div className={styles.searchBox}>
                        <SearchBox>
                            <SearchItem>
                                <XInput
                                    label='配送单号'
                                    placeholder='请输入配送单号'
                                    value={deliveryId}
                                    bindThis={this}
                                    bindName='deliveryId'
                                />
                            </SearchItem>
                            <SearchItem>
                                <XInput
                                    label='通话ID'
                                    placeholder='请输入通话ID'
                                    value={recordId}
                                    bindThis={this}
                                    bindName='recordId'
                                />
                            </SearchItem>
                            <SearchItem>
                                <div className={styles.component}>
                                    <div className={styles.label}>通信号码</div>
                                    <div className={styles.inputBox}>
                                        <Input.Group compact>
                                            <Select
                                                value={callItem.code}
                                                style={{ width: '100px' }}
                                                placeholder='请选择'
                                                onChange={(e, item) => {
                                                    if (e)
                                                        this.setState({ callItem: { code: item.value, value: item.children }, tel: null });
                                                }}>
                                                {
                                                    callTypes.map(item => {
                                                        return <Option key={item.code} value={item.code}>{item.value}</Option>;
                                                    })
                                                }
                                            </Select>
                                            <Input
                                                disabled={!callItem.code}
                                                value={tel}
                                                style={{ width: '150px' }}
                                                placeholder='请输入号码'
                                                onChange={e => this.setState({ tel: e.target.value })}
                                            />
                                        </Input.Group>
                                    </div>
                                </div>
                            </SearchItem>
                            <SearchItem>
                                <XSelect
                                    label='通信类型'
                                    placeholder='请选择通信类型'
                                    renderData={types}
                                    dataIndex='value'
                                    keyIndex='code'
                                    value={typeItem.value}
                                    bindThis={this}
                                    bindName='typeItem'
                                />
                            </SearchItem>
                            <SearchItem>
                                <XDatePicker
                                    datePickerStyle={{ width: '180px' }}
                                    label='通话时间'
                                    placeholder='请选择开始时间'
                                    value={startTime}
                                    showTime={false}
                                    disabledDate={current => {
                                        if (current && releaseTime && current > releaseTime.endOf('days')) {
                                            return true;
                                        }
                                    }}
                                    onChange={time => this.setState({ startTime: time })}
                                />
                                <XDatePicker
                                    style={{ marginRight: '20px' }}
                                    datePickerStyle={{ width: '180px' }}
                                    placeholder='请选择结束时间'
                                    value={releaseTime}
                                    showTime={false}
                                    disabledDate={current => {
                                        if (current && startTime && current < startTime) {
                                            return true;
                                        }
                                    }}
                                    onChange={time => this.setState({ releaseTime: time })}
                                />
                            </SearchItem>
                            <SearchItem>
                                <XOKButton
                                    label='查询'
                                    onClick={this._searchHandle}
                                />
                                <XCancelButton
                                    label='重置'
                                    onClick={this._resetHandle}
                                />
                            </SearchItem>
                        </SearchBox>
                    </div>
                    {/* <XOKButton
                        style={{ width: '90px' }}
                        label='生成报表'
                        onClick={this._createCancel}
                    /> */}
                    <XTableAdapter render={scrollY => this.setState({ scrollY })}>
                        <TableContent
                            renderData={virtualNoRecords}
                            history={history}
                            paginationChange={this._paginationChange}
                            scrollY={scrollY}
                            tableHandle={this._tableHandle}
                        />
                    </XTableAdapter>
                    {this._renderModal()}
                </div>
            </KeepAlive>
        );
    }
}
export default connect((state) => ({
    virtualNoRecords: state.virtualno.virtualNoRecords
}), {
    ...model.actions,
    setBreadcrumbPaths
})(VirtualNo);